export default __webpack_public_path__ + "static/media/bolinhas6.f600ec0a.svg";